import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import isEmail from 'validator/es/lib/isEmail';

@Directive({
  selector: '[appEmail]',
  providers: [{ provide: NG_VALIDATORS, useExisting: AppEmailValidator, multi: true }]
})
export class AppEmailValidator implements Validator {
  @Input() appEmailDomain?: string;

  validate(control: AbstractControl): ValidationErrors | null {
    const value = (control.value || '').trim();
    const email = this.appEmailDomain ? `${value}@${this.appEmailDomain}` : value;
    return value && !isEmail(email) ? { email: true } : null;
  }
}
